export const API_METHODS = {
	GET: 'GET',
	POST: 'POST',
	PUT: 'PUT',
	PATCH: 'PATCH',
	DELETE: 'DELETE',
	OPTIONS: 'OPTIONS',
};

const CONSENT_DELEGATED_STATUS_CODES = {
	status: '530',
};
const SCREENING_RESCREENING_STATUS_CODES = {
	status: '580',
	cancelled: '0',
};
const SCREENING_FAILED_STATUS_CODES = {
	cancelled: '6800',
};
const SCREENING_REQUIRED_STATUS_CODES = {
	status: '550',
	cancelled: '0',
};
const SCREENING_PASSED_STATUS_CODES = {
	status: '600',
};
export const PATIENT_SCREENING_STATUS_CODE = {
	CONSENT_DELEGATED_STATUS_CODES,
	SCREENING_FAILED_STATUS_CODES,
	SCREENING_REQUIRED_STATUS_CODES,
	SCREENING_PASSED_STATUS_CODES,
	SCREENING_RESCREENING_STATUS_CODES,
};
export enum Status {
	Candidate = 100,
	Approved = 500,
	ReadyToEngage = 510,
	Engaged = 520,
	ConsentDelegated = 530,
	Consented = 550,
	Dispatched = 560,
	ReScreening = 580,
	Screened = 600,
	Contacted = 602,
	Scheduled = 604,
	Screening = 606,
	Randomised = 610,
}

export enum CancelledStatus {
	NotCancelled = 0,
	Denied = 3000,
	NotEligible = 6500,
	ScreeningNotEligible = 6800,
	RandomisingExcluded = 6900,
	OptedOut = 2000,
}

export const cookieConsentFeatureFlag = true;

export const supportEmail = 'research@umed.io';
export const patientSupportEmailUk = 'patientsupport@umed.io';
export const patientSupportEmailUs = 'patientservices@accesspd.org';
export const patientSupportPhoneNumberUk = '0808 304 9869';
export const patientSupportPhoneNumberUs = '1 888 454 5580';

const isProdSite = import.meta.env.VITE_SITE_ENV === 'prod';

export const defaultSiteLanguage = import.meta.env.VITE_SITE_LOCALE === 'us' ? 'en-us' : 'en-gb';
export const isUs = defaultSiteLanguage === 'en-us';
export const phoneNumberPrefix = isUs ? '+1' : '+44';

export const RUDDERSTACK_SETUP = {
	WRITE_KEY: isProdSite ? '2YFoApdBMScrKTmD47sirBGMxtU' : '2Vvm8tADMCJaJXKRdhslYbodktd',
	DATA_PLANE_URL: 'https://umedleemutmvd.dataplane.rudderstack.com',
};

const oneTrustDevKey = '01948437-cc06-7ee7-a9fe-2fb1e45eca3c-test';
const ukOneTrustProdKey = '01948437-cc06-7ee7-a9fe-2fb1e45eca3c'; // use as default
const usOneTrustProdKeys: { [key: string]: string } = {
	'us.umed.io': '', // No analytics required
	'm.accesspd.org': '018e7558-d513-79a6-8a24-7199cfaaf307',
	'm.accessild.org': '018e7560-68d1-723b-8fa9-b24582c88d34',
	'm.accesscmd.org': '018e7560-ec07-79a1-a38c-cb170f40267a',
};
const currentHostname = window.location.hostname;
const oneTrustKey = isProdSite
	? usOneTrustProdKeys[currentHostname] || ukOneTrustProdKey
	: oneTrustDevKey;

export const ONETRUST_SETUP = {
	KEY: oneTrustKey,
	SCRIPT_SRC: 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js',
	ANALYTICS_CATEGORY_ID: 'ANLYT',
};

export const available_languages: { [key: string]: string } = {
	'en-gb': 'English (UK)',
	'en-us': 'English (US)',
	'fr-ca': 'French (Canada)',
	'es-us': 'Spanish (US)',
};

const ukPhoneRegEx = /^[0]{1}[0-9]{10}$/;
const usPhoneRegEx = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
export const phoneRegex = isUs ? usPhoneRegEx : ukPhoneRegEx;

export const SURVEY_JS_KEY = 'NmU1NGYwMjMtZDJjMi00MjE1LTliNTEtZjY1NmYyNTI5NGNhOzE9MjAyNS0xMC0yNQ==';

export const optOutOptions = [
	{ label: 'Patient is not eligible', value: 'not_eligible' },
	{ label: 'Patient lost capacity to participate', value: 'participation_capacity' },
	{
		label: 'Patient is unable to get to study site visits or site too far',
		value: 'study_sites',
	},
	{ label: 'Patient is unable to commit the time', value: 'time' },
	{ label: 'Patient did not provide any reason', value: 'no_reason' },
	{ label: 'Inadequate financial incentive', value: 'financial' },
	{ label: 'Other', value: 'other' },
];

export const roles = {
	CARE_AGENT: 'care_agent',
	STUDY_SITE_ADMIN: 'study_site_admin',
	PATIENT_APPROVER: 'patient_approver',
	STUDY_METRICS: 'study_metrics',
	TRIAL_SITES: 'trial_sites_user',
	FLU_SNIFF: 'flu_sniff_user',
	FLU_SNIFF_PLUS_APPROVER: 'flusniff_plus_approver',
};

export const SIDE_NAVIGATION_MENU = {
	WIDTH: {
		DEFAULT: 'w-[64px]',
		EXPANDED: 'w-[240px]',
	},
	PADDING_LEFT: {
		DEFAULT: 'pl-[64px]',
		EXPANDED: 'pl-[240px]',
	},
	CALCULATED_WIDTH_VIEW: {
		DEFAULT: 'w-[calc(100vw-64px)]',
		EXPANDED: 'w-[calc(100vw-240px)]',
	},
	CALCULATED_WIDTH_PERCENT: {
		DEFAULT: '!w-[calc(100%-64px)]',
		EXPANDED: '!w-[calc(100%-240px)]',
	},
	MINIMUM_WIDTH: {
		EXPANDED: 'min-w-[240px]',
	},
};

export const screeningAndConsentSurveyType = 'screening';
